// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Common = require("../utils/Common.res.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var MM_cmp_api = require("../api/MM_cmp_api.res.js");
var MM_context = require("../mm-utils/MM_context.res.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.res.js");
var Core__Option = require("@rescript/core/src/Core__Option.res.js");
var Core__Result = require("@rescript/core/src/Core__Result.res.js");
var MM_api_editor = require("../api/MM_api_editor.res.js");
var MM_cmp_editor = require("./MM_cmp_editor.res.js");
var Belt_SetString = require("rescript/lib/js/belt_SetString.js");
var MM_cmp_pe_index = require("../explorer/MM_cmp_pe_index.res.js");
var MM_cmp_settings = require("./MM_cmp_settings.res.js");
var MM_react_common = require("../ui-utils/MM_react_common.res.js");
var MM_wrk_settings = require("../worker/MM_wrk_settings.res.js");
var Expln_React_Modal = require("../../rescript-utils/main/react-components/Expln_React_Modal.res.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.res.js");
var Expln_utils_common = require("../../rescript-utils/main/Expln_utils_common.res.js");
var MM_wrk_editor_json = require("../test/MM_wrk_editor_json.res.js");
var Expln_React_UseTabs = require("../../rescript-utils/main/react-components/Expln_React_UseTabs.res.js");
var Local_storage_utils = require("../ui-utils/Local_storage_utils.res.js");
var MM_cmp_tabs_manager = require("./MM_cmp_tabs_manager.res.js");
var MM_wrk_pre_ctx_data = require("../worker/MM_wrk_pre_ctx_data.res.js");
var Styles = require("@mui/material/styles");
var MM_cmp_pe_frame_full = require("../explorer/MM_cmp_pe_frame_full.res.js");
var Belt_MutableSetString = require("rescript/lib/js/belt_MutableSetString.js");
var Expln_utils_jsonParse = require("../../rescript-utils/main/Expln_utils_jsonParse.res.js");
var MM_cmp_context_selector = require("./MM_cmp_context_selector.res.js");
var Expln_React_ContentWithStickyHeader = require("../../rescript-utils/main/react-components/Expln_React_ContentWithStickyHeader.res.js");

var settingsSymbol = React.createElement("img", {
      className: "settings-img"
    });

var pencilSymbol = React.createElement("img", {
      className: "pencil-img"
    });

var magnifyingGlassSymbol = React.createElement("img", {
      className: "magnifying-glass-img"
    });

var turnstileSymbol = React.createElement("img", {
      className: "turnstile-img"
    });

function createInitialState(settings) {
  return {
          preCtxData: MM_wrk_pre_ctx_data.preCtxDataMake(settings),
          ctxSelectorIsExpanded: true
        };
}

function updatePreCtxData(st, settings, ctx) {
  return {
          preCtxData: MM_wrk_pre_ctx_data.preCtxDataUpdate(st.preCtxData, settings, ctx),
          ctxSelectorIsExpanded: st.ctxSelectorIsExpanded
        };
}

function updateCtxSelectorIsExpanded(st, ctxSelectorIsExpanded) {
  return {
          preCtxData: st.preCtxData,
          ctxSelectorIsExpanded: ctxSelectorIsExpanded
        };
}

var mainTheme = Styles.createTheme({
      palette: {
        white: {
          main: "#ffffff"
        },
        grey: {
          main: "#e0e0e0"
        },
        lightgrey: {
          main: "#e2e2e2"
        },
        red: {
          main: "#FF0000"
        },
        pastelred: {
          main: "#FAA0A0"
        },
        orange: {
          main: "#FF7900"
        },
        yellow: {
          main: "#FFE143"
        }
      }
    });

var editorsOrderLocStorKey = "editors-order";

function readEditorsOrderFromLocStor() {
  var orderStr = Local_storage_utils.locStorReadString(editorsOrderLocStorKey);
  if (orderStr === undefined) {
    return [];
  }
  var parseRes = Expln_utils_jsonParse.parseJson(orderStr, (function (__x) {
          return Expln_utils_jsonParse.asArr(__x, (function (__x) {
                        return Expln_utils_jsonParse.asObj(__x, (function (o) {
                                      return {
                                              editorId: Expln_utils_jsonParse.$$int(o, "editorId", undefined, undefined)
                                            };
                                    }), undefined, undefined);
                      }), undefined, undefined);
        }), undefined, (function () {
          return [];
        }));
  if (parseRes.TAG === "Ok") {
    return parseRes._0;
  } else {
    return [];
  }
}

function saveEditorsOrderToLocStor(editorsOrder) {
  Local_storage_utils.locStorWriteString(editorsOrderLocStorKey, Expln_utils_common.stringify(editorsOrder));
}

function getNewEditorIdFromEditorsOrder(editorsOrder) {
  var existingIds = editorsOrder.map(function (ord) {
        return ord.editorId;
      });
  var newId = 0;
  while(existingIds.includes(newId)) {
    newId = newId + 1 | 0;
  };
  return newId;
}

function updateEditorsDataInLocStor() {
  var oldEditorStateStr = Local_storage_utils.locStorReadString(MM_cmp_editor.editorStateLocStorKey);
  if (oldEditorStateStr !== undefined) {
    var editorsOrder = readEditorsOrderFromLocStor();
    var newEditorId = getNewEditorIdFromEditorsOrder(editorsOrder);
    editorsOrder.splice(0, 0, {
          editorId: newEditorId
        });
    saveEditorsOrderToLocStor(editorsOrder);
    Local_storage_utils.locStorWriteString(MM_cmp_editor.getEditorLocStorKey(newEditorId), oldEditorStateStr);
    var oldHistReg = Local_storage_utils.locStorReadString(MM_cmp_editor.editorHistRegLocStorKey);
    if (oldHistReg !== undefined) {
      Local_storage_utils.locStorWriteString(MM_cmp_editor.getEditorHistLocStorKey(newEditorId), oldHistReg);
    }
    
  }
  Local_storage_utils.locStorDeleteKey(MM_cmp_editor.editorStateLocStorKey);
  Local_storage_utils.locStorDeleteKey(MM_cmp_editor.editorHistRegLocStorKey);
  Local_storage_utils.locStorDeleteKey(MM_cmp_editor.editorHistTmpLocStorKey);
}

updateEditorsDataInLocStor();

function deleteOutdatedEditorsDataInLocStor() {
  var existingEditorIds = readEditorsOrderFromLocStor().map(function (d) {
        return d.editorId;
      });
  var allowedLocStorKeys = Belt_SetString.fromArray(existingEditorIds.map(MM_cmp_editor.getEditorLocStorKey).concat(existingEditorIds.map(MM_cmp_editor.getEditorHistLocStorKey)));
  var locStorLen = Local_storage_utils.locStorLength();
  var keysToDelete = Belt_MutableSetString.make();
  var editorLocStorKeyPrefix = MM_cmp_editor.editorStateLocStorKey + "-";
  var editorHistLocStorKeyPrefix = MM_cmp_editor.editorHistLocStorKey + "-";
  for(var i = 0; i < locStorLen; ++i){
    var key = Local_storage_utils.locStorKey(i);
    if (key !== undefined && (key.startsWith(editorLocStorKeyPrefix) || key.startsWith(editorHistLocStorKeyPrefix)) && !Belt_SetString.has(allowedLocStorKeys, key)) {
      Belt_MutableSetString.add(keysToDelete, key);
    }
    
  }
  Belt_MutableSetString.forEach(keysToDelete, Local_storage_utils.locStorDeleteKey);
}

function readEditorStateFromJsonStr(str) {
  return Core__Result.mapOr(MM_wrk_editor_json.readEditorStateFromJsonStr(str), undefined, (function (res) {
                return res;
              }));
}

var $$location = window.location;

var initialStateSafeBase64 = new URLSearchParams($$location.search).get("editorState");

var editorInitialStateFromUrl = !(initialStateSafeBase64 == null) ? (MM_react_common.removeQueryParamsFromUrl("removing editorState from the URL"), readEditorStateFromJsonStr(Common.safeBase64ToStr(initialStateSafeBase64))) : undefined;

function getNewEditorId(existingTabs) {
  var existingIds = [];
  existingTabs.forEach(function (t) {
        var match = t.data;
        if (typeof match !== "object") {
          return ;
        }
        if (match.TAG !== "Editor") {
          return ;
        }
        existingIds.push(match._0.editorId);
      });
  var newId = 0;
  while(existingIds.includes(newId)) {
    newId = newId + 1 | 0;
  };
  return newId;
}

function makeNewTabTitle(existingTabs, prefix) {
  var existingTitles = existingTabs.map(function (t) {
        return t.label;
      });
  var newId = 1;
  var makeTitle = function (i) {
    return prefix + " [" + i.toString() + "]";
  };
  var newTitle = makeTitle(newId);
  while(existingTitles.includes(newTitle)) {
    newId = newId + 1 | 0;
    newTitle = makeTitle(newId);
  };
  return newTitle;
}

function getNewExplorerTabTitle(existingTabs, initPatternFilterStrOpt, initDependsOnFilterOpt) {
  var initPatternFilterStr = initPatternFilterStrOpt !== undefined ? initPatternFilterStrOpt : "";
  var initDependsOnFilter = initDependsOnFilterOpt !== undefined ? initDependsOnFilterOpt : "";
  if (initPatternFilterStr.length <= 0) {
    if (initDependsOnFilter.length > 0) {
      return ("Dependents of " + initDependsOnFilter).substring(0, 40);
    } else {
      return makeNewTabTitle(existingTabs, "EXPLORER");
    }
  }
  var substrInc = initPatternFilterStr.startsWith("$+ ") ? 3 : 0;
  return initPatternFilterStr.substring(substrInc, 40 + substrInc | 0);
}

function synchEditorsDataInLocStor(existingTabs) {
  var editorsOrder = [];
  existingTabs.forEach(function (tab) {
        var match = tab.data;
        if (typeof match !== "object") {
          return ;
        }
        if (match.TAG !== "Editor") {
          return ;
        }
        editorsOrder.push({
              editorId: match._0.editorId
            });
      });
  saveEditorsOrderToLocStor(editorsOrder);
  deleteOutdatedEditorsDataInLocStor();
}

var contextFromUrlHasBeenReloaded = {
  contents: false
};

function MM_cmp_root(props) {
  var modalRef = Expln_React_Modal.useModalRef();
  var match = React.useState(function () {
        
      });
  var setLastOpenedEditorId = match[1];
  var lastOpenedEditorId = match[0];
  var beforeTabRemove = function (tab) {
    var match = tab.data;
    if (typeof match !== "object") {
      return Promise.resolve(false);
    }
    switch (match.TAG) {
      case "Editor" :
          var editorId = match._0.editorId;
          return MM_react_common.openOkCancelDialog(modalRef, "Close editor tab?", undefined, undefined, tab.label, undefined, undefined).then(function (confirmed) {
                      if (confirmed) {
                        MM_api_editor.deleteEditor(editorId);
                        if (Caml_obj.equal(lastOpenedEditorId, editorId)) {
                          setLastOpenedEditorId(function (param) {
                                
                              });
                        }
                        
                      }
                      return confirmed;
                    });
      case "ExplorerIndex" :
      case "ExplorerFrame" :
          return Promise.resolve(true);
      
    }
  };
  var match$1 = Expln_React_UseTabs.useTabs(beforeTabRemove);
  var updateTabs = match$1.updateTabs;
  var setLabel = match$1.setLabel;
  var activeTabId = match$1.activeTabId;
  var tabs = match$1.tabs;
  var removeTab = match$1.removeTab;
  var moveTabRight = match$1.moveTabRight;
  var moveTabLeft = match$1.moveTabLeft;
  var openTab = match$1.openTab;
  var match$2 = React.useState(function () {
        return createInitialState(MM_cmp_settings.settingsReadFromLocStor());
      });
  var setState = match$2[1];
  var state = match$2[0];
  var match$3 = React.useState(function () {
        return true;
      });
  var setShowTabs = match$3[1];
  var showTabs = match$3[0];
  var reloadCtx = React.useRef(undefined);
  var addAsrtByLabel = React.useRef(undefined);
  var toggleCtxSelector = React.useRef(null);
  var match$4 = React.useState(function () {
        return false;
      });
  var setCanStartSynchTabsOrder = match$4[1];
  var canStartSynchTabsOrder = match$4[0];
  React.useEffect((function () {
          if (canStartSynchTabsOrder) {
            synchEditorsDataInLocStor(tabs);
          }
          
        }), [
        canStartSynchTabsOrder,
        tabs
      ]);
  var isEditorTab = function (tabData) {
    if (typeof tabData !== "object" || tabData.TAG !== "Editor") {
      return ;
    } else {
      return tabData._0;
    }
  };
  React.useEffect((function () {
          var tab = tabs.find(function (tab) {
                return tab.id === activeTabId;
              });
          if (tab !== undefined) {
            var match = isEditorTab(tab.data);
            if (match !== undefined) {
              var editorId = match.editorId;
              setLastOpenedEditorId(function (param) {
                    return editorId;
                  });
              MM_api_editor.setLastOpenedEditorId(editorId);
              addAsrtByLabel.current = Core__Option.map(match.addAsrtByLabel.contents, (function (addAsrtByLabelOrig) {
                      return function (str) {
                        return addAsrtByLabelOrig(str).then(function (res) {
                                    if (res.TAG === "Ok") {
                                      openTab(activeTabId);
                                    }
                                    return res;
                                  });
                      };
                    }));
            }
            
          }
          
        }), [activeTabId]);
  var actSettingsUpdated = function (newSettings) {
    MM_cmp_settings.settingsSaveToLocStor(newSettings);
    setState(function (__x) {
          return updatePreCtxData(__x, newSettings, undefined);
        });
    if (!(state.preCtxData.settingsV.val.descrRegexToDisc !== newSettings.descrRegexToDisc || state.preCtxData.settingsV.val.labelRegexToDisc !== newSettings.labelRegexToDisc || state.preCtxData.settingsV.val.descrRegexToDepr !== newSettings.descrRegexToDepr || state.preCtxData.settingsV.val.labelRegexToDepr !== newSettings.labelRegexToDepr)) {
      return Promise.resolve({
                  TAG: "Ok",
                  _0: undefined
                });
    }
    var reloadCtx$1 = reloadCtx.current;
    if (reloadCtx$1 !== undefined) {
      return reloadCtx$1(state.preCtxData.srcs, newSettings, true);
    } else {
      return Promise.resolve({
                  TAG: "Error",
                  _0: "The reloadCtx() function is not initialized in MM_cmp_root."
                });
    }
  };
  var actCtxSelectorExpandedChange = function (expanded) {
    setState(function (__x) {
          return updateCtxSelectorIsExpanded(__x, expanded);
        });
  };
  var actRenameTab = function (id, newName) {
    setLabel(id, newName);
    tabs.forEach(function (tab) {
          if (tab.id !== id) {
            return ;
          }
          var match = isEditorTab(tab.data);
          if (match !== undefined) {
            return Core__Option.forEach(match.updateTabTitle.contents, (function (updateTabTitle) {
                          updateTabTitle(newName);
                        }));
          }
          
        });
  };
  var actMoveTab = function (id, toRight) {
    var curIdx = Core__Array.findIndexOpt(tabs, (function (t) {
            return t.id === id;
          }));
    if (curIdx === undefined) {
      return ;
    }
    var newIdx = toRight ? curIdx + 1 | 0 : curIdx - 1 | 0;
    if (2 <= newIdx) {
      if (toRight) {
        return moveTabRight(id);
      } else {
        return moveTabLeft(id);
      }
    }
    
  };
  var actMoveTabLeft = function (id) {
    actMoveTab(id, false);
  };
  var actMoveTabRight = function (id) {
    actMoveTab(id, true);
  };
  var actCloseTab = function (tabId) {
    var tab = tabs.find(function (t) {
          return t.id === tabId;
        });
    if (tab !== undefined && tab.closable) {
      return removeTab(tab.id);
    }
    
  };
  var openFrameExplorer = function (label) {
    setState(function (st) {
          var match = MM_context.getFrame(st.preCtxData.ctxV.val.full, label);
          if (match !== undefined) {
            updateTabs(function (tabsSt) {
                  var tab = Expln_React_UseTabs.getTabs(tabsSt).find(function (tab) {
                        var tabData = tab.data;
                        var label$1 = label;
                        if (typeof tabData !== "object") {
                          return false;
                        }
                        if (tabData.TAG !== "ExplorerFrame") {
                          return false;
                        }
                        var lbl = tabData.label;
                        return Belt_Option.mapWithDefault(label$1, true, (function (label) {
                                      return lbl === label;
                                    }));
                      });
                  if (tab !== undefined) {
                    return Expln_React_UseTabs.openTab(tabsSt, tab.id);
                  } else {
                    return Expln_React_UseTabs.addTab(tabsSt, Caml_option.some(turnstileSymbol), label, true, undefined, {
                                  TAG: "ExplorerFrame",
                                  label: label
                                }, true)[0];
                  }
                });
          } else {
            MM_react_common.openInfoDialog(modalRef, undefined, undefined, undefined, "Cannot find an assertion by label '" + label + "'", undefined, undefined, undefined, undefined);
          }
          return st;
        });
  };
  var actOpenExplorer = function (initPatternFilterStrOpt, initDependsOnFilterOpt) {
    var initPatternFilterStr = initPatternFilterStrOpt !== undefined ? initPatternFilterStrOpt : "";
    var initDependsOnFilter = initDependsOnFilterOpt !== undefined ? initDependsOnFilterOpt : "";
    updateTabs(function (tabsSt) {
          var newTabTitle = getNewExplorerTabTitle(Expln_React_UseTabs.getTabs(tabsSt), initPatternFilterStr.trim(), initDependsOnFilter.trim());
          return Expln_React_UseTabs.addTab(tabsSt, Caml_option.some(magnifyingGlassSymbol), newTabTitle, true, undefined, {
                        TAG: "ExplorerIndex",
                        initPatternFilterStr: initPatternFilterStr,
                        initDependsOnFilter: initDependsOnFilter
                      }, true)[0];
        });
  };
  var setTabTitle = function (editorStateLocStor, existingTabs) {
    if (editorStateLocStor.tabTitle.trim() !== "") {
      return editorStateLocStor;
    }
    var newTabTitle = makeNewTabTitle(existingTabs, "EDITOR");
    return {
            tabTitle: newTabTitle,
            srcs: editorStateLocStor.srcs,
            descr: editorStateLocStor.descr,
            varsText: editorStateLocStor.varsText,
            disjText: editorStateLocStor.disjText,
            stmts: editorStateLocStor.stmts
          };
  };
  var actOpenEditor = function (initialStateLocStor) {
    updateTabs(function (tabsSt) {
          var initialStateLocStor$1;
          if (initialStateLocStor !== undefined) {
            initialStateLocStor$1 = setTabTitle(initialStateLocStor, Expln_React_UseTabs.getTabs(tabsSt));
          } else {
            var newTabTitle = makeNewTabTitle(Expln_React_UseTabs.getTabs(tabsSt), "EDITOR");
            initialStateLocStor$1 = MM_wrk_editor_json.makeEmptyEditorStateLocStor(newTabTitle);
          }
          var newEditorId = getNewEditorId(Expln_React_UseTabs.getTabs(tabsSt));
          return Expln_React_UseTabs.addTab(tabsSt, Caml_option.some(pencilSymbol), initialStateLocStor$1.tabTitle, true, undefined, {
                        TAG: "Editor",
                        _0: {
                          editorId: newEditorId,
                          initialStateLocStor: initialStateLocStor$1,
                          addAsrtByLabel: {
                            contents: undefined
                          },
                          updateTabTitle: {
                            contents: undefined
                          }
                        }
                      }, true)[0];
        });
    if (initialStateLocStor !== undefined) {
      return Core__Option.forEach(reloadCtx.current, (function (reloadCtx) {
                    reloadCtx(initialStateLocStor.srcs, state.preCtxData.settingsV.val, undefined);
                  }));
    }
    
  };
  React.useEffect((function () {
          updateTabs(function (st) {
                var st$1;
                if (Expln_React_UseTabs.getTabs(st).length === 0) {
                  var match = Expln_React_UseTabs.addTab(st, Caml_option.some(settingsSymbol), "", false, undefined, "Settings", undefined);
                  var match$1 = Expln_React_UseTabs.addTab(match[0], undefined, "Tabs", false, undefined, "TabsManager", undefined);
                  var st$2 = Core__Array.reduceWithIndex(readEditorsOrderFromLocStor(), match$1[0], (function (st, param, idx) {
                          var editorId = param.editorId;
                          var editorStateJsonStr = Local_storage_utils.locStorReadString(MM_cmp_editor.getEditorLocStorKey(editorId));
                          if (editorStateJsonStr === undefined) {
                            return st;
                          }
                          var editorStateLocStor = readEditorStateFromJsonStr(editorStateJsonStr);
                          if (editorStateLocStor === undefined) {
                            return st;
                          }
                          var editorStateLocStor$1 = setTabTitle(editorStateLocStor, Expln_React_UseTabs.getTabs(st));
                          return Expln_React_UseTabs.addTab(st, Caml_option.some(pencilSymbol), editorStateLocStor$1.tabTitle, true, undefined, {
                                        TAG: "Editor",
                                        _0: {
                                          editorId: editorId,
                                          initialStateLocStor: editorStateLocStor$1,
                                          addAsrtByLabel: {
                                            contents: undefined
                                          },
                                          updateTabTitle: {
                                            contents: undefined
                                          }
                                        }
                                      }, idx === 0 && Core__Option.isNone(editorInitialStateFromUrl))[0];
                        }));
                  st$1 = Expln_React_UseTabs.addTab(st$2, Caml_option.some(magnifyingGlassSymbol), "EXPLORER", true, undefined, {
                          TAG: "ExplorerIndex",
                          initPatternFilterStr: "",
                          initDependsOnFilter: ""
                        }, !Expln_React_UseTabs.getTabs(st$2).some(function (t) {
                              return Core__Option.isSome(isEditorTab(t.data));
                            }))[0];
                } else {
                  st$1 = st;
                }
                setCanStartSynchTabsOrder(function (param) {
                      return true;
                    });
                return st$1;
              });
          if (editorInitialStateFromUrl !== undefined && !contextFromUrlHasBeenReloaded.contents) {
            contextFromUrlHasBeenReloaded.contents = true;
            actOpenEditor(editorInitialStateFromUrl);
          }
          
        }), []);
  var tmp = {};
  var tmp$1 = state.preCtxData.settingsV.val.hideContextSelector && !state.ctxSelectorIsExpanded ? "none" : undefined;
  if (tmp$1 !== undefined) {
    tmp.display = tmp$1;
  }
  return React.createElement(Styles.ThemeProvider, {
              theme: mainTheme,
              children: React.createElement(Expln_React_ContentWithStickyHeader.make, {
                    top: 0,
                    header: React.createElement(Expln_React_Column.make, {
                          children: Caml_option.some(null)
                        }, React.createElement(MM_cmp_context_selector.make, {
                              modalRef: modalRef,
                              settings: state.preCtxData.settingsV.val,
                              onUrlBecomesTrusted: (function (url) {
                                  actSettingsUpdated(MM_wrk_settings.markUrlAsTrusted(state.preCtxData.settingsV.val, url));
                                }),
                              onChange: (function (srcs, ctx) {
                                  setState(function (__x) {
                                        return updatePreCtxData(__x, undefined, [
                                                    srcs,
                                                    ctx
                                                  ]);
                                      });
                                }),
                              reloadCtx: reloadCtx,
                              style: tmp,
                              onExpandedChange: actCtxSelectorExpandedChange,
                              doToggle: toggleCtxSelector
                            }), showTabs ? match$1.renderTabs() : React.createElement("div", {
                                style: {
                                  display: "none"
                                }
                              })),
                    content: (function (contentTop) {
                        return React.createElement(Expln_React_Column.make, {
                                    children: Caml_option.some(null)
                                  }, tabs.map(function (__x) {
                                        var match = __x.data;
                                        var tmp;
                                        if (typeof match !== "object") {
                                          tmp = match === "Settings" ? React.createElement(MM_cmp_settings.make, {
                                                  modalRef: modalRef,
                                                  preCtxData: state.preCtxData,
                                                  onChange: actSettingsUpdated
                                                }) : React.createElement(MM_cmp_tabs_manager.make, {
                                                  modalRef: modalRef,
                                                  tabs: tabs.slice(2).map(function (tab) {
                                                        return {
                                                                id: tab.id,
                                                                icon: tab.icon,
                                                                label: tab.label
                                                              };
                                                      }),
                                                  onTabRename: actRenameTab,
                                                  onTabMoveUp: actMoveTabLeft,
                                                  onTabMoveDown: actMoveTabRight,
                                                  onTabFocus: openTab,
                                                  onTabClose: actCloseTab,
                                                  onOpenExplorer: (function () {
                                                      actOpenExplorer(undefined, undefined);
                                                    }),
                                                  onOpenEditor: (function () {
                                                      actOpenEditor(undefined);
                                                    })
                                                });
                                        } else {
                                          switch (match.TAG) {
                                            case "Editor" :
                                                var match$1 = match._0;
                                                tmp = React.createElement(MM_cmp_editor.make, {
                                                      modalRef: modalRef,
                                                      editorId: match$1.editorId,
                                                      preCtxData: state.preCtxData,
                                                      top: contentTop,
                                                      reloadCtx: reloadCtx,
                                                      addAsrtByLabel: match$1.addAsrtByLabel,
                                                      updateTabTitle: match$1.updateTabTitle,
                                                      initialStateLocStor: match$1.initialStateLocStor,
                                                      toggleCtxSelector: toggleCtxSelector,
                                                      ctxSelectorIsExpanded: state.ctxSelectorIsExpanded,
                                                      showTabs: showTabs,
                                                      setShowTabs: (function (b) {
                                                          setShowTabs(function (param) {
                                                                return b;
                                                              });
                                                        }),
                                                      openFrameExplorer: openFrameExplorer,
                                                      onTabTitleChange: (function (__x$1) {
                                                          var tabId = __x.id;
                                                          var newVerifiedTitle;
                                                          if (__x$1.trim() === "") {
                                                            var tab = tabs.find(function (tab) {
                                                                  return tab.id === tabId;
                                                                });
                                                            newVerifiedTitle = tab !== undefined ? tab.label : __x$1;
                                                          } else {
                                                            newVerifiedTitle = __x$1;
                                                          }
                                                          actRenameTab(tabId, newVerifiedTitle);
                                                        })
                                                    });
                                                break;
                                            case "ExplorerIndex" :
                                                tmp = React.createElement(MM_cmp_pe_index.make, {
                                                      modalRef: modalRef,
                                                      preCtxData: state.preCtxData,
                                                      tabTitle: __x.label,
                                                      openFrameExplorer: openFrameExplorer,
                                                      openExplorer: actOpenExplorer,
                                                      toggleCtxSelector: toggleCtxSelector,
                                                      ctxSelectorIsExpanded: state.ctxSelectorIsExpanded,
                                                      initPatternFilterStr: match.initPatternFilterStr,
                                                      initDependsOnFilter: match.initDependsOnFilter,
                                                      addAsrtByLabel: addAsrtByLabel,
                                                      onTabTitleChange: (function (newTitle) {
                                                          actRenameTab(__x.id, newTitle);
                                                        })
                                                    });
                                                break;
                                            case "ExplorerFrame" :
                                                tmp = React.createElement(MM_cmp_pe_frame_full.make, {
                                                      top: contentTop,
                                                      modalRef: modalRef,
                                                      preCtxData: state.preCtxData,
                                                      label: match.label,
                                                      openFrameExplorer: openFrameExplorer,
                                                      openExplorer: actOpenExplorer,
                                                      openEditor: (function (editorStateLocStor) {
                                                          actOpenEditor(editorStateLocStor);
                                                        }),
                                                      toggleCtxSelector: toggleCtxSelector,
                                                      ctxSelectorIsExpanded: state.ctxSelectorIsExpanded
                                                    });
                                                break;
                                            
                                          }
                                        }
                                        return React.createElement("div", {
                                                    key: __x.id,
                                                    style: {
                                                      display: __x.id === activeTabId ? "block" : "none"
                                                    }
                                                  }, tmp);
                                      }), React.createElement(Expln_React_Modal.make, {
                                        modalRef: modalRef
                                      }), React.createElement(MM_cmp_api.make, {
                                        modalRef: modalRef
                                      }));
                      })
                  })
            });
}

var make = MM_cmp_root;

exports.settingsSymbol = settingsSymbol;
exports.pencilSymbol = pencilSymbol;
exports.magnifyingGlassSymbol = magnifyingGlassSymbol;
exports.turnstileSymbol = turnstileSymbol;
exports.createInitialState = createInitialState;
exports.updatePreCtxData = updatePreCtxData;
exports.updateCtxSelectorIsExpanded = updateCtxSelectorIsExpanded;
exports.mainTheme = mainTheme;
exports.editorsOrderLocStorKey = editorsOrderLocStorKey;
exports.readEditorsOrderFromLocStor = readEditorsOrderFromLocStor;
exports.saveEditorsOrderToLocStor = saveEditorsOrderToLocStor;
exports.getNewEditorIdFromEditorsOrder = getNewEditorIdFromEditorsOrder;
exports.updateEditorsDataInLocStor = updateEditorsDataInLocStor;
exports.deleteOutdatedEditorsDataInLocStor = deleteOutdatedEditorsDataInLocStor;
exports.readEditorStateFromJsonStr = readEditorStateFromJsonStr;
exports.$$location = $$location;
exports.editorInitialStateFromUrl = editorInitialStateFromUrl;
exports.getNewEditorId = getNewEditorId;
exports.makeNewTabTitle = makeNewTabTitle;
exports.getNewExplorerTabTitle = getNewExplorerTabTitle;
exports.synchEditorsDataInLocStor = synchEditorsDataInLocStor;
exports.contextFromUrlHasBeenReloaded = contextFromUrlHasBeenReloaded;
exports.make = make;
/* settingsSymbol Not a pure module */
